import { useState } from 'react';
import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import { HeroSection } from '@/components/sections/HeroSection';
import { LoanSimulator } from '@/components/sections/LoanSimulator';
import { BankPartners } from '@/components/sections/BankPartners';
import { AboutSection } from '@/components/sections/AboutSection';
import { CTASection } from '@/components/sections/CTASection';
import { ContactForm } from '@/components/ContactForm';
import { LegalNoticeModal } from '@/components/LegalNoticeModal';
import { PrivacyPolicyModal } from '@/components/PrivacyPolicyModal';

function App() {
    const [isContactOpen, setIsContactOpen] = useState(false);
    const [isLegalOpen, setIsLegalOpen] = useState(false);
    const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);

    const openContact = () => setIsContactOpen(true);
    const closeContact = () => setIsContactOpen(false);

    const openLegal = () => setIsLegalOpen(true);
    const closeLegal = () => setIsLegalOpen(false);

    const openPrivacy = () => setIsPrivacyOpen(true);
    const closePrivacy = () => setIsPrivacyOpen(false);

    return (
        <div className="min-h-screen bg-background">
            <Header onContactClick={openContact} />
            <main>
                <HeroSection />
                <LoanSimulator onContactClick={openContact} />
                <BankPartners />
                <AboutSection onContactClick={openContact} />
                <CTASection onContactClick={openContact} />
            </main>
            <Footer 
                onContactClick={openContact} 
                onLegalClick={openLegal}
                onPrivacyClick={openPrivacy}
            />
            
            {/* Contact Form Modal */}
            <ContactForm isOpen={isContactOpen} onClose={closeContact} />
            
            {/* Legal Notice Modal */}
            <LegalNoticeModal isOpen={isLegalOpen} onClose={closeLegal} />
            
            {/* Privacy Policy Modal */}
            <PrivacyPolicyModal isOpen={isPrivacyOpen} onClose={closePrivacy} />
        </div>
    );
}

export default App;
